import { useSiteMaterial } from 'features';
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, CardsListSkeleton, Grid, Page, Section } from 'ui';

import { SampleListSelect } from '../../components/SampleListSelect/SampleListSelect';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const SamplesEdit = () => {
  const navigate = useNavigate();
  const { data: siteMaterial } = useSiteMaterial();

  return (
    <Page>
      <Page.Title title="Edit samples" />
      <Page.Divider />
      <Grid container>
        <Grid item xs={12} md={4}>
          <Section title="Site Details">
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid item xs={12} md={8}>
          <Section
            title="Sample details"
            action={
              <Button size="large" fullWidth variant="secondary" onClick={() => navigate(-1)}>
                Cancel
              </Button>
            }
          >
            <Suspense fallback={<CardsListSkeleton />}>
              <SampleListSelect siteMaterialId={siteMaterial.public_id} onClose={() => navigate(-1)} />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
